import {
  ResponseTypeEnum,
  TemplateNodeSchema,
} from '@ulysses-inc/harami_api_client'

// ResponseType 毎にバリデーションを行い、無効な場合は ResponseType を undefined にする
export const resetInvalidResponseTypes = (templateNodes: {
  [key: string]: TemplateNodeSchema
}) => {
  const validatedTemplateNodes: { [key: string]: TemplateNodeSchema } = {
    ...templateNodes,
  }

  for (const node of Object.values(templateNodes)) {
    if (!node) {
      continue
    }
    if (node.question) {
      switch (node.question.responseType) {
        case ResponseTypeEnum.RESPONSE_SET:
          // ひな形に設定したセット選択肢を削除した場合、 responseMultipleChoiceSets が undefined になるため、質問種別を undefined にする
          if (
            !node.question.responseMultipleChoiceSets ||
            node.question.responseMultipleChoiceSets.length === 0
          ) {
            const clonedNode = structuredClone(node)
            if (clonedNode.question) {
              clonedNode.question.responseType = undefined
            }
            validatedTemplateNodes[node.id] = clonedNode
          }
          break
        default:
          break
      }
    }
  }

  return validatedTemplateNodes
}
